import { useCallback } from 'react';
import { getCurrencyByCountry } from 'commons/utils';

interface UseIsForeignTransactionProps {
  storeCountry: string;
}

interface UseIsForeignTransactionReturn {
  isForeignTransaction: (currency: string, exchangeRate: number) => boolean;
  localCurrency: string;
}

export const useIsForeignTransaction = ({
  storeCountry,
}: UseIsForeignTransactionProps): UseIsForeignTransactionReturn => {
  const localCurrency = getCurrencyByCountry(storeCountry) || '';

  const isForeignTransaction = useCallback(
    (currency: string, exchangeRate: number): boolean => {
      return currency !== localCurrency && exchangeRate > 0;
    },
    [localCurrency],
  );

  return { isForeignTransaction, localCurrency };
};
